
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { getLevel, getDataLevel } from '@/services/http';
import { dateTimeFormatter, readCookie } from '@/tools/tools';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import GradeRule from '@/components/rule/gradeRule.vue';

@Component({
  components: {
    Header,
    Footer,
    NavMenu,
    GradeRule
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    }
  }
})
export default class extends Vue {
  loading: boolean = false // 加载

  moreEquity: boolean = false

  @State('user') data: any // 用户信息

  gradeData: any[] = [] // 等级中心数据

  activeIndex: number = 0 // 当前等级下标

  // 所有权益列表
  allEquityList: any[] = [
    {
      code: 1,
      name: '硬件商品',
      icon: 'iconyingjian9zhe'
    },
    {
      code: 2,
      name: '耗材商品',
      icon: 'iconhaocai9zhe'
    },
    {
      code: 3,
      name: '硬件商品包邮',
      icon: 'iconbaoyou'
    },
    {
      code: 4,
      name: '优先发货',
      icon: 'iconyouxianfahuo'
    },
    {
      code: 5,
      name: '急速售后',
      icon: 'iconjisushouhou'
    },
    {
      code: 6,
      name: '天无理由退货',
      icon: 'iconwuliyoutuihuo'
    },
    {
      code: 7,
      name: '天无理由换货',
      icon: 'iconwuliyouhuanhuo'
    },
    {
      code: 8,
      name: '生日送积分',
      icon: 'iconshengrisongjifen'
    },
    {
      code: 9,
      name: '积分加成',
      icon: 'iconxingzhuangjiehe1'
    }
  ]

  equityList: any[] = [] // 显示权益列表

  recordList: any[] = [] // 积分记录列表

  isLoading: boolean = false // 表格加载

  ruleList: any[] = [] // 积分规则列表

  // 用户积分等级
  level: number = 0

  nextLevelList: any[] = [] // 当前等级可升级的列表

  currentpage: number = 1 // 当前页数

  totalnumber: number = 10 // 总条数

  pageNo: number = 1 // 当前页

  pageSize: number = 10 // 当前条数

  showRule: boolean = false // 是否显示规则说明

  private async created() {
    await this.getData(); // 等级中心数据
    this.getDataLevel(); // 1.53埋点
    // await this.getRecordList(); // 积分记录列表 2020.7.10更改
    // await this.getRuleList(); // 积分规则列表 2020.7.10更改
  }

  // 切换标签页
  private changeActiveIndex(index: number) {
    this.activeIndex = index;
    this.getEquityList();
  }

  // handleSizeChange(pageSize: number) {
  //   this.pageSize = pageSize;
  //   this.getRecordList();
  // }

  // handleCurrentChange(pageNo: number) {
  //   this.pageNo = pageNo;
  //   this.getRecordList();
  // }

  // 获取等级中心信息
  private async getData() {
    this.loading = true;
    const res: any = await getLevel({
      companyId: 1
    });
    if (res.data.code === 100) {
      this.gradeData = res.data.data;
      this.level = res.data.data.level;
      this.moreEquity = true;
      // 格式化当前等级可升级的列表
      this.nextLevelList = (this as any).gradeData.levelList.filter(
        (e: any) => e.level >= res.data.data.level
      )

      // 格式化当前等级共几项权益
      ;(this as any).nextLevelList = (this as any).nextLevelList.map((item: any) => {
        const data: any = item;
        data.num = item.equity ? item.equity.split(',') : [];
        data.num = data.num.map(parseFloat);
        return data;
      });
      this.getEquityList()

      // 格式化成长规则列表
      ;(this as any).gradeData.growthRuleList = (this as any).gradeData.growthRuleList.map(
        (item: any) => {
          const data: any = item;
          data.list = item.rules ? item.rules.split(',') : [];
          data.list = data.list.map(parseFloat);
          return data;
        }
      );
    } else {
      this.$message.error(res.data.message);
    }
    this.loading = false;
  }

  // 获取积分记录列表
  // private async getRecordList() {
  //   const res: any = await getIntegral({
  //     pageNo: this.pageNo,
  //     pageSize: this.pageSize
  //   });
  //   if (res.data.code === 100) {
  //     this.recordList = res.data.data.list;
  //     this.totalnumber = res.data.data.total;
  //   } else {
  //     (this as any).$message.error(res.data.message);
  //   }
  // }

  // 获取当前等级下的权益列表
  private getEquityList() {
    this.equityList = [];
    for (let i = 0; i < this.allEquityList.length; i += 1) {
      for (let j = 0; j < (this as any).nextLevelList[this.activeIndex].num.length; j += 1) {
        if (this.allEquityList[i].code === (this as any).nextLevelList[this.activeIndex].num[j]) {
          this.equityList.push(this.allEquityList[i]);
        }
      }
    }
  }

  // 获取积分规则列表
  // private async getRuleList() {
  //   const res: any = await getIntegralRule();
  //   if (res.data.code === 100) {
  //     this.ruleList = res.data.data.ruleList;
  //   } else {
  //     this.$message.error(res.data.message);
  //   }
  // }

  // 1.53埋点
  private getDataLevel() {
    const anchor = readCookie('anchor');
    getDataLevel({
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: '3.1.1.0.0.0.1',
      level: this.level,
      companyId: 1
    });
  }
}
